import React, {useEffect, useRef, useState} from 'react';
import {useLocation} from "react-router-dom";
import {DownloadTableExcel} from "react-export-table-to-excel";
import Loader from "../Loader";
import Button from "../UI/Button";

const Download = (props) => {
  //debugger
  const myLocation = useLocation();

  const tablePrintRef = useRef()
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState(<></>);

  useEffect(() => {

    if (myLocation.state) {

      const columns = myLocation.state.data.columns;
      const data = myLocation.state.data.data;


      const headerFields = [];
      const headerTitles = [];
      columns.map((v) => {
        headerFields.push(v.field)
        headerTitles.push(v.title)
      });

      const titles = <>
        <tr>{headerTitles.map((v, index) => <th key={index}>{v}</th>)}</tr>
      </>
      const rows = <>
        {data.map((singleRow, indexOfSingleRow) => <tr key={indexOfSingleRow}>{headerFields.map((field, indexField) =>
          <td key={indexField}>{singleRow[field]}</td>)}</tr>)}
      </>


      const result = <>
        <thead>{titles}</thead>
        <tbody>{rows}</tbody>
      </>

      //debugger
      setData(result);
      // setIsLoading(false)
    }


    return
  },[]);


  return (

      <>
        <div className={"table-responsive"} style={{height: '80vh', width: '100%', margin: "auto"}}>
          <div className={"mx-5"}>
            <DownloadTableExcel
              filename="table"
              sheet="users"
              currentTableRef={tablePrintRef.current}
            >
              <Button style={{background: '#309383', color: 'white'}}> دانلود جدول به صورت فایل اکسل...</Button>
            </DownloadTableExcel>
          </div>
          <div style={{
            maxWidth: '90vw',
            overflowX: 'scroll',
            height: '70vh',
            border: "1px solid black",
            borderRadius: 10,
            margin: '1rem'
          }}>
            <table className={"table"} ref={tablePrintRef} style={{
              opacity: '0.5', textAlign: "center", margin: '1rem',
              background: ' rgb(197 201 206 / 44%)'
            }}>
              {data}
            </table>
          </div>

        </div>
      </>

  );
};

export default Download;
